export enum TeamsTableHeader {
  ProjectTeamMember = 'Project / Team member',
  DeliveryManager = 'Delivery manager',
  NextEvaluation = 'Next evaluation',
  Rate = 'Rate',
  Allocation = 'Allocation',
  // HappinessScore = 'Happiness score',
  SowStartDate = 'SOW start',
  SowEndDate = 'SOW end',
}

export const TEAMS_TABLE_HEADERS: TeamsTableHeader[] = [
  TeamsTableHeader.ProjectTeamMember,
  TeamsTableHeader.DeliveryManager,
  TeamsTableHeader.NextEvaluation,
  TeamsTableHeader.SowStartDate,
  TeamsTableHeader.SowEndDate,
  TeamsTableHeader.Rate,
  TeamsTableHeader.Allocation,
  // TeamsTableHeader.HappinessScore,
];

export const HEADER_WIDTHS: Record<TeamsTableHeader, string> = {
  [TeamsTableHeader.ProjectTeamMember]: '24%',
  [TeamsTableHeader.DeliveryManager]: '20%',
  [TeamsTableHeader.NextEvaluation]: '12%',
  [TeamsTableHeader.SowStartDate]: '12%',
  [TeamsTableHeader.SowEndDate]: '12%',
  [TeamsTableHeader.Rate]: '10%',
  [TeamsTableHeader.Allocation]: '10%',
  // [TeamsTableHeader.HappinessScore]: '15%',
};
